export default __webpack_public_path__ + "static/media/image13.a71e527d.png";